import { createContext, useState } from 'react';
import { useComposerCategories } from './useComposerCategories';
import { useComposersCount } from './useComposersCount';
export { useComposerData } from './hook';
export const TemplateDataContext = createContext(null);
export function ComposerDataProvider(props) {
    const { initialComposerId = null, initialParentId, children, onClose } = props;
    const { composersCount, loading: loadingCount, error: countError } = useComposersCount();
    const { categories, loading: loadingCategories, error: categoriesError } = useComposerCategories();
    const loading = loadingCount || loadingCategories;
    const error = Boolean(countError || categoriesError);
    const [selectedComposerId, setSelectedComposerId] = useState(initialComposerId);
    const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const defaultTemplateFilter = composersCount['templates:company'] > 0 ? 'templates:company' : 'templates:included';
    const [userDefinedTemplatesFilter, setTemplatesFilter] = useState(undefined);
    const templatesFilter = userDefinedTemplatesFilter || defaultTemplateFilter;
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const selectComposer = (id) => setSelectedComposerId(id);
    const goBackToSelect = () => setSelectedComposerId(null);
    const addCategoryId = (id) => setSelectedCategoryIds([...selectedCategoryIds, id]);
    const removeCategoryId = (id) => setSelectedCategoryIds(selectedCategoryIds.filter((categoryId) => categoryId !== id));
    const addSelectedLanguage = (languageCode) => {
        if (!selectedLanguages.includes(languageCode)) {
            setSelectedLanguages([...selectedLanguages, languageCode]);
        }
    };
    const removeSelectedLanguage = (languageCode) => setSelectedLanguages(selectedLanguages.filter((code) => code !== languageCode));
    const value = {
        error,
        categories,
        loading,
        selectedComposerId,
        selectedCategoryIds,
        searchQuery,
        templatesAmount: composersCount,
        templatesFilter,
        selectedLanguages,
        initialParentId,
        goBackToSelect,
        addCategoryId,
        removeCategoryId,
        selectComposer,
        setSearchQuery,
        setTemplatesFilter,
        addSelectedLanguage,
        removeSelectedLanguage,
        closeDialog: onClose,
    };
    return <TemplateDataContext.Provider value={value}>{children}</TemplateDataContext.Provider>;
}
